export const CSS_CLASSES = {
  GLOBAL_HEADER_ROOT: "global-header",
  GLOBAL_HEADER_STICKY: "global-header-sticky",
  GLOBAL_HEADER_DESKTOP: "global-header-desktop",
  GLOBAL_HEADER_MOBILE: "global-header-mobile",

  /* Main Header */
  GLOBAL_HEADER_MAIN_ROOT: "global-header-main",
  GLOBAL_HEADER_MAIN_LIGHT: "global-header-main-light",
  GLOBAL_HEADER_MAIN_DARK: "global-header-main-dark",
  GLOBAL_HEADER_MAIN_CONTENT: "global-header-main-content",
  GLOBAL_HEADER_MAIN_LEFT_SECTION: "global-header-main-left-section",
  GLOBAL_HEADER_MAIN_LEFT_SECTION_REVERSE: "global-header-main-left-section-reverse",
  GLOBAL_HEADER_MAIN_RIGHT_SECTION: "global-header-main-right-section",

  /* Logo */
  GLOBAL_HEADER_LOGO: "global-header-logo",
  GLOBAL_HEADER_LOGO_DESKTOP: "global-header-logo-desktop",
  GLOBAL_HEADER_LOGO_MOBILE: "global-header-logo-mobile",

  /* Nav Bar - Mobile */
  GLOBAL_HEADER_MOBILE_NAV_MENU_ROOT: "global-header-mobile-nav-menu",
  GLOBAL_HEADER_MOBILE_NAV_MENU_CONTENT: "global-header-mobile-nav-menu-content",
  GLOBAL_HEADER_MOBILE_NAV_CTA_BUTTONS: "global-header-mobile-nav-cta-buttons",
  GLOBAL_HEADER_MOBILE_NAV_ICON_LINKS: "global-header-mobile-nav-icon-links",
  GLOBAL_HEADER_MOBILE_NAV_LINKS: "global-header-mobile-nav-links",

  /* CTA Buttons */
  GLOBAL_HEADER_CTA_BUTTONS: "global-header-cta-buttons",

  /* Utility Header */
  GLOBAL_HEADER_UTILITY_ROOT: "global-header-utility",
  GLOBAL_HEADER_UTILITY_LIGHT: "global-header-utility-light",
  GLOBAL_HEADER_UTILITY_DARK: "global-header-utility-dark",
  GLOBAL_HEADER_UTILITY_CONTENT: "global-header-utility-content",
  GLOBAL_HEADER_UTILITY_CONTENT_ALIGN_LEFT: "global-header-utility-content-align-left",
  GLOBAL_HEADER_UTILITY_CONTENT_ALIGN_CENTER: "global-header-utility-content-align-center",
  GLOBAL_HEADER_UTILITY_CONTENT_ALIGN_RIGHT: "global-header-utility-content-align-right",
  GLOBAL_HEADER_UTILITY_CONTENT_ALIGN_SPACE_BETWEEN: "global-header-utility-content-align-space-between",
  GLOBAL_HEADER_UTILITY_CONTENT_ALIGN_SPACE_AROUND: "global-header-utility-content-align-space-around",
  GLOBAL_HEADER_UTILITY_CONTENT_ALIGN_SPACE_EVENLY: "global-header-utility-content-align-space-evenly",
  GLOBAL_HEADER_UTILITY_LINKS: "global-header-utility-links",
  GLOBAL_HEADER_UTILITY_LINK: "global-header-utility-link",
  GLOBAL_HEADER_UTILITY_ICON_LINKS: "global-header-utility-icon-links",
  GLOBAL_HEADER_UTILITY_ICON_LINK: "global-header-utility-icon-link",
  GLOBAL_HEADER_UTILITY_LINK_SEPARATOR: "global-header-utility-link-separator",

  /* User Menu */
  GLOBAL_HEADER_USER_MENU_ROOT: "global-header-user-menu",
  GLOBAL_HEADER_USER_MENU_INTERACTIVE: "global-header-user-menu-interactive",
  GLOBAL_HEADER_USER_MENU_PRIMARY: "global-header-user-menu-primary",
  GLOBAL_HEADER_USER_MENU_ITEM: "global-header-user-menu-item",
  GLOBAL_HEADER_USER_MENU_ITEM_MOBILE: "global-header-user-menu-item-mobile",
  GLOBAL_HEADER_USER_MENU_ITEM_USER_MENU_BUTTON: "global-header-user-menu-item-user-menu-button",
  GLOBAL_HEADER_USER_MENU_ITEM_USER_MENU_BUTTON_MOBILE: "global-header-user-menu-item-user-menu-button-mobile",
  GLOBAL_HEADER_USER_MENU_ITEM_HIGHLIGHTED: "global-header-user-menu-item-highlighted",
  GLOBAL_HEADER_USER_MENU_ITEM_END_SPACER: "global-header-user-menu-item-end-spacer",

  /* User Menu Button */
  GLOBAL_HEADER_USER_MENU_BUTTON: "global-header-user-menu-button",
  GLOBAL_HEADER_USER_MENU_BUTTON_DARK: "global-header-user-menu-button-dark",
  GLOBAL_HEADER_USER_MENU_BUTTON_LIGHT: "global-header-user-menu-button-light",
  GLOBAL_HEADER_USER_MENU_BUTTON_PRIMARY: "global-header-user-menu-button-primary",
  GLOBAL_HEADER_USER_MENU_BUTTON_INTERACTIVE: "global-header-user-menu-button-interactive",
  GLOBAL_HEADER_USER_MENU_BUTTON_END_ICON: "global-header-user-menu-button-end-icon",
  GLOBAL_HEADER_USER_MENU_DRAWER_CONTENT: "global-header-user-menu-drawer-content",
  GLOBAL_HEADER_USER_MENU_DRAWER_CONTENT_OFFSET_LIGHT: "global-header-user-menu-drawer-content-offset-light",
  GLOBAL_HEADER_USER_MENU_DRAWER_CONTENT_OFFSET_DARK: "global-header-user-menu-drawer-content-offset-dark",

  /* Global Header Lite */
  GLOBAL_HEADER_LITE_ROOT: "global-header-lite",
  GLOBAL_HEADER_LITE_DARK: "global-header-lite-dark",
  GLOBAL_HEADER_LITE_STICKY: "global-header-lite-sticky",
  GLOBAL_HEADER_LITE_DESKTOP: "global-header-lite-desktop",

  GLOBAL_HEADER_LITE_MAIN_BAR: "global-header-lite-main-bar",
  GLOBAL_HEADER_LITE_MAIN_BAR_CONTENT: "global-header-lite-main-bar-content",

  GLOBAL_HEADER_LITE_UTILITY_BAR: "global-header-lite-utility-bar",
  GLOBAL_HEADER_LITE_UTILITY_BAR_CONTENT: "global-header-lite-utility-bar-content",

  GLOBAL_HEADER_LITE_UTILITY_LINKS: "global-header-lite-utility-links",
  GLOBAL_HEADER_LITE_UTILITY_LINK: "global-header-lite-utility-link",
  GLOBAL_HEADER_LITE_UTILITY_ICON_LINKS: "global-header-lite-utility-icon-links",
  GLOBAL_HEADER_LITE_UTILITY_ICON_LINK: "global-header-lite-utility-icon-link",
  GLOBAL_HEADER_LITE_UTILITY_LINK_SEPARATOR: "global-header-lite-utility-link-separator",

  GLOBAL_HEADER_LITE_MOBILE_MENU: "global-header-lite-mobile-menu",
  GLOBAL_HEADER_LITE_MOBILE_MENU_BUTTON: "global-header-lite-mobile-menu-button",
  GLOBAL_HEADER_LITE_MOBILE_MENU_CONTENT: "global-header-lite-mobile-menu-content",
  GLOBAL_HEADER_LITE_MOBILE_MENU_CLOSE_BUTTON: "global-header-lite-mobile-menu-close-button",
  GLOBAL_HEADER_LITE_MOBILE_MENU_USER_CONTENT: "global-header-lite-mobile-menu-user-content",

  GLOBAL_HEADER_LITE_CTA_BUTTONS: "global-header-lite-cta-buttons",

  GLOBAL_HEADER_LITE_USER_MENU: "global-header-lite-user-menu",
  GLOBAL_HEADER_LITE_USER_MENU_BUTTON: "global-header-lite-user-menu-button",
  GLOBAL_HEADER_LITE_USER_MENU_LIST: "global-header-lite-user-menu-list",
  GLOBAL_HEADER_LITE_USER_MENU_LIST_PRIMARY: "global-header-lite-user-menu-list-primary",
  GLOBAL_HEADER_LITE_USER_MENU_LIST_INTERACTIVE: "global-header-lite-user-menu-list-interactive",
  GLOBAL_HEADER_LITE_USER_MENU_LIST_MOBILE_TOP_OFFSET: "global-header-lite-user-menu-list-mobile-top-offset",
  GLOBAL_HEADER_LITE_USER_MENU_LIST_DESKTOP: "global-header-lite-user-menu-list-desktop",
  GLOBAL_HEADER_LITE_USER_MENU_ITEM_BUTTON: "global-header-lite-user-menu-item-button",
};
